import React from 'react'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadCrumbNav,
} from '../../container/Document/styles'

const BreadcrumbNavigate = ({ onClick, itemRef, options = [], label }) => {
  return (
    <Breadcrumb>
      <BreadCrumbNav>
        <BreadcrumbList>
          {options.map((crumb, i) => (
            <BreadcrumbItem
              ref={itemRef ? (ref) => itemRef(ref, i) : null}
              key={i.toString() + (crumb?.name || 'breadcrumb')}
              onClick={onClick ? () => onClick(crumb, i) : null}
            >
              {crumb?.name || label}
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </BreadCrumbNav>
    </Breadcrumb>
  )
}

export default BreadcrumbNavigate
